// extracted by mini-css-extract-plugin
module.exports = {"not-found":"not-found_not-found__c-UfP","error":"not-found_error__2Fmdy","info":"not-found_info__3m2MJ","buttons":"not-found_buttons__3LZyg"};